export class ClinicFilters {
    telephone?: any;
    address?: any;
    townId?: any;
    provinceId?: any;
}